import { useState, useEffect } from 'react';
import HeroSimulator from './HeroSimulator';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/1b6afd142227f5c47286a838fd52f71f.jpg)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black mb-6 leading-tight">
            Transporteur Coursier & Location d'Utilitaire avec Chauffeur en Île-de-France
          </h1>
          
          <p className="text-lg md:text-xl mb-8 max-w-4xl mx-auto leading-relaxed font-medium opacity-90">
            Vous recherchez un partenaire de confiance pour vos transports en Île-de-France ? Que ce soit pour une livraison de colis urgente par <strong>coursier express</strong> ou pour la <strong>location d'un utilitaire avec chauffeur expérimenté</strong>, nous intervenons rapidement dans tous les départements franciliens.
          </p>

          {/* Simulateur de prix rouge */}
          <HeroSimulator />

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mt-10">
            <a
              href="tel:+33632410246"
              className="group bg-gradient-to-r from-orange-500 to-red-500 text-white px-10 py-5 rounded-full text-lg font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 flex items-center gap-3 whitespace-nowrap"
            >
              <i className="ri-phone-line text-2xl"></i>
              <span>Appelez maintenant</span>
            </a>
            <a
              href="sms:+33632410246?body=Bonjour%2C%20je%20souhaite%20obtenir%20un%20devis%20gratuit%20pour%20un%20transport.%20Merci%20de%20me%20recontacter%20avec%20les%20d%C3%A9tails%20et%20tarifs.%20Cordialement."
              className="group bg-white/95 backdrop-blur-sm text-gray-900 px-10 py-5 rounded-full text-lg font-bold hover:bg-white hover:shadow-2xl hover:scale-105 transition-all duration-300 flex items-center gap-3 whitespace-nowrap"
            >
              <i className="ri-message-2-line text-2xl"></i>
              <span>Devis gratuit</span>
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-4xl font-black mb-2">24/7</div>
              <div className="text-sm opacity-90">Service disponible</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-black mb-2">&lt;1h</div>
              <div className="text-sm opacity-90">Livraison express</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-black mb-2">100%</div>
              <div className="text-sm opacity-90">Sécurisé</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-black mb-2">8</div>
              <div className="text-sm opacity-90">Départements IDF</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white opacity-75"></i>
      </div>
    </section>
  );
}
